import axios from '../util/request'
import qs from 'qs'
const md5 = require('js-md5')
const stamp = Date.now()

export const collectInfo = (data) => {
  data.stamp = stamp
  data.sign = md5(`${data.info_type}${data.mobile}${stamp}${atob(localStorage.getItem('okey'))}`)
  return axios.post('/api/xiaosen/user/info/submitCollectInfo',qs.stringify(data))
}